import React from 'react';

import { Button } from '@@/ui/primitives';
import { clsx } from 'clsx';
import { LucideIcon } from 'lucide-react';

interface TabButtonProps {
  icon: LucideIcon;
  label: string;
  isActive: boolean;
  isVisible: boolean;
  disabled?: boolean;
  onClick: () => void;
  alertCount?: number;
  badge?: React.ReactNode;
  ariaLabel: string;
}

export const TabButton = (props: TabButtonProps) => {
  return (
    <Button
      variant='ghost'
      size='sm'
      disabled={props.disabled}
      onClick={props.onClick}
      className={clsx(
        'text-sm! font-medium! px-0!',
        'rounded-none h-12',
        'hover:bg-inherit',
        props.isActive && props.isVisible
          ? 'text-slate-950 shadow-[inset_0_-6px_0_0_var(--color-slate-500)]'
          : 'text-primary/70'
      )}
      aria-label={props.ariaLabel}
    >
      <props.icon className='size-4' />
      {props.label}
      {props.alertCount && props.alertCount > 0 ? (
        <div
          className={clsx(
            'flex items-center justify-center w-8 h-6',
            'font-semibold tabular-nums',
            'text-sm rounded-full',
            'bg-red-100 text-red-950',
            !props.isActive && 'opacity-70'
          )}
        >
          {props.alertCount > 9 ? '9+' : props.alertCount}
        </div>
      ) : null}
    </Button>
  );
};
